module.exports = __webpack_public_path__ + "img/chevron-left-violet.6702102d.svg";